import { ServiceConfig } from '@user/store/services/config'
import { get } from '@user/store/services/crud'
import { useEffect, useState } from 'react'
import { toast } from '@sales-center/components'
import { IContactDTO } from '../typings'

const baseUrl = `${ServiceConfig.baseAPIUrl}/Contact`

export const useGetContactOnMount = (contactId: number | undefined) => {
  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>()
  const [contact, setContact] = useState<IContactDTO | undefined>()

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      if (contactId) {
        try {
          if (mounted) {
            setStatus('pending')
            const response = await get(`${baseUrl}/${contactId}`)
            if (response.ok) {
              setContact(await response.json())
              setStatus('success')
            } else {
              setStatus('fail')
              toast.error('Error loading contact.')
            }
          }
        } catch {
          if (mounted) {
            setStatus('fail')
          }
        }
      } else {
        setContact(undefined)
        setStatus('success')
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [contactId])

  return { contact, status }
}
